import {AbstractControl, FormControl, FormGroup, FormGroupDirective, NgForm, ValidationErrors} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

export class CustomValidators {

  static password(control: AbstractControl): ValidationErrors | null {
    let error: string | null = null;

    const value: string = control.value as string;

    if (!value || value.length < 8) {
      error = $localize`:Form Validation|Password too short@@form-validation-password-too-short:Minimum Password length is` + ' 8';
    } else if (!/.*[a-z].*/.test(value)) {
      error = $localize`:Form Validation|Password does not contain lower case chars@@form-validation-password-no-lowercase:Password should contain at least 1 lowercase letter`;
    } else if (!/.*[A-Z].*/.test(value)) {
      error = $localize`:Form Validation|Password does not contain upper case chars@@form-validation-password-no-uppercase:Password should contain at least 1 uppercase letter`;
    } else if (!/.*[0-9].*/.test(value)) {
      error = $localize`:Form Validation|Password does not contain numbers@@form-validation-password-no-number:Password should contain at least 1 number`;
    } else if (/^[\s]+.*/.test(value)) {
      error = $localize`:Form Validation|Password starts with spaces@@form-validation-password-whitespaces-start:Password should not start with whitespaces or empty characters`;
    } else if (/.*[\s]+$/.test(value)) {
      error = $localize`:Form Validation|Password ends with spaces@@form-validation-password-whitespaces-end:Password should not end with  whitespaces or empty characters`;
    }

    return !error ? null : {
      password: {
        error
      }
    };
  }

  static phoneNumber(control: AbstractControl): ValidationErrors | null {
    let error: string | null = null;

    const value: string = control.value as string;

    if (value && !/^[+][0-9]+$/.test(value)) {
      error = $localize`:Form Validation|Phone number invalid format@@form-validation-phone-invalid-format:A phone number must start with a plus (+) sign, followed immediately by the country code and number`;
    }

    return !error ? null : {
      phone: {
        error
      }
    };
  }

  static phoneNumberEx(control: AbstractControl): ValidationErrors | null {
    let error: string | null = null;

    const value: string = control.value as string;

    if (value && !/^[+]?[0-9()\-]+$/.test(value)) {
      error = $localize`:Form Validation|Phone number invalid format@@form-validation-phone-invalid-format:A phone number must start with a plus (+) sign, followed immediately by the country code and number`;
    }

    return !error ? null : {
      phone: {
        error
      }
    };
  }

  static passwordsMatch(group: FormGroup) { // here we have the 'passwords' group
    const password = group.get('password');
    const pass = password ? password.value as string : null;

    const confirmPassword = group.get('confirmPass');
    const confirmPass = confirmPassword ? confirmPassword.value as string : null;

    return pass === confirmPass ? null : {mismatch: true};
  }

  static enrolTimeCorrect(group: FormGroup) {
    const start = CustomValidators.parseDate(group.get('enrolStartsAtDate'), group.get('enrolStartsAtTime'));
    const end = CustomValidators.parseDate(group.get('enrolEndsAtDate'), group.get('enrolEndsAtTime'));

    const enrolEndsDate = group.get('enrolEndsAtDate')?.value as Date;
    const endsAtDate = group.get('endsAtDate')?.value as Date;

    if (enrolEndsDate && endsAtDate && enrolEndsDate?.toDateString() == endsAtDate?.toDateString()) {
      const overallEnd = CustomValidators.parseDate(group.get('endsAtDate'), group.get('endsAtTime'));

      if (overallEnd && end && end >= overallEnd) {
        return {enrolTimeIncorrect: true};
      }
    }

    return start != null && end != null && start < end ? null : {enrolTimeIncorrect: true};
  }

  static startTimeCorrect(group: FormGroup) {
    const start = CustomValidators.parseDate(group.get('startsAtDate'), group.get('startsAtTime'));
    const end = CustomValidators.parseDate(group.get('endsAtDate'), group.get('endsAtTime'));

    return start != null && end != null && start < end ? null : {startTimeIncorrect: true};
  }

  private static parseDate(dateField: AbstractControl | null,
                           timeField: AbstractControl | null): Date | null {
    let date: Date | null = null;
    if (timeField && timeField.value && (timeField.value as string).includes(':')) {
      const values = (timeField.value as string).split(':');
      date = dateField && dateField.value ? <Date>dateField.value : new Date();
      date.setHours(Number.parseInt(values[0]), Number.parseInt(values[1]), 0);
    }
    return date;
  }
}

abstract class CustomErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return (control != null && control.invalid && control.dirty)
      || (
        control != null
        && control.parent != null
        && control.parent.hasError(this.errorCode)
        && control.parent.dirty
      );
  }

  abstract get errorCode(): string;
}

export class MismatchErrorStateMatcher extends CustomErrorStateMatcher {
  get errorCode(): string {
    return 'mismatch';
  }
}

export class EnrolTimeMismatchErrorStateMatcher extends CustomErrorStateMatcher {
  get errorCode(): string {
    return 'enrolTimeIncorrect';
  }
}

export class StartTimeMismatchErrorStateMatcher extends CustomErrorStateMatcher {
  get errorCode(): string {
    return 'startTimeIncorrect';
  }
}
